module.exports = "mat-form-field{\r\n    width: 100%;\r\n}"